import { useForm } from '@presentation/hooks'
import { SelectApi } from '@presentation/components/molecules'

export const LocalSelectApi: React.FC = () => {
  const { control, formState } = useForm()

  return (
    <SelectApi
      label="Local"
      name="local"
      path={`/locais?sort_by=nome`}
      control={control}
      error={formState?.errors.local?.message}
      isRequired
    />
  )
}

export default LocalSelectApi
